module.exports = __webpack_public_path__ + "img/ring_y_0_0_0@2x.d2e61347.png";